export * from '@primeuix/themes/lara/inlinemessage';
export { default } from '@primeuix/themes/lara/inlinemessage';
